import axios from 'axios'
import u from '@/utils'

const fetchHoneyRoles = async query => {
  let url = `/api/v1/honeyRoles`
  if (url) url = `/api/v1/honeyRoles?${query}&size=20&page=1`
  const { data } = await axios.get(url)
  const sortByName = data._embedded.honeyRoles.map(honeyRole =>
    u.processResp(honeyRole)
  )
  return sortByName.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
}

export default {
  fetchHoneyRoles
}
